module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serviceCharge":"Service charge {serviceCharge}%","discount":"Discount {discount}% off","price":"$ {price}","total":"Total:"},"zh-tw":{"serviceCharge":"服務費 {serviceCharge}%","discount":"優惠折扣 {discount}%","price":"{price} 元","total":"總計:"}}')
  delete Component.options._Ctor
}
